import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, User, Settings, LogOut } from "lucide-react";

const SidebarUserProfile = ({ user, userAccessLevel, logout }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const initials = user?.first_name?.charAt(0)?.toUpperCase() || "A";

  return (
    <div className="relative" style={{ borderTop: "1px solid var(--lm-border)" }}>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute bottom-full left-3 right-3 mb-2 rounded-xl overflow-hidden z-20"
            style={{ backgroundColor: "var(--lm-s2)", border: "1px solid var(--lm-border)" }}>
            <div className="p-1">
              {[
                { icon: User, label: t('sidebar.userMenu.profile') },
                { icon: Settings, label: t('sidebar.userMenu.settings') },
              ].map(({ icon: Icon, label }) => (
                <button key={label}
                  className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors"
                  style={{ color: "var(--lm-ink-2)" }}
                  onMouseEnter={e => { e.currentTarget.style.backgroundColor = "var(--lm-s3)"; e.currentTarget.style.color = "var(--lm-ink)"; }}
                  onMouseLeave={e => { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.color = "var(--lm-ink-2)"; }}>
                  <Icon className="w-4 h-4" />
                  {label}
                </button>
              ))}
              <div style={{ height: "1px", backgroundColor: "var(--lm-border)", margin: "4px 0" }} />
              <button onClick={logout}
                className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors"
                style={{ color: "var(--lm-error)" }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = "rgba(239,68,68,0.08)")}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}>
                <LogOut className="w-4 h-4" />
                {t('sidebar.userMenu.logout')}
              </button>
            </div>
          </div>
        </>
      )}

      <div className="p-3 space-y-2">
        <button onClick={() => setOpen(o => !o)}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl transition-colors"
          style={{ backgroundColor: "transparent" }}
          onMouseEnter={e => (e.currentTarget.style.backgroundColor = "var(--lm-s2)")}
          onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}>
          <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 text-sm font-semibold"
            style={{ backgroundColor: "rgba(94,106,210,0.2)", color: "#828fff" }}>
            {initials}
          </div>
          <div className="flex-1 min-w-0 text-left">
            <p className="text-sm font-medium truncate" style={{ color: "var(--lm-ink)" }}>
              {user?.first_name} {user?.last_name}
            </p>
            <p className="text-xs truncate" style={{ color: "var(--lm-ink-3)" }}>{userAccessLevel}</p>
          </div>
          <ChevronDown className="w-3.5 h-3.5 flex-shrink-0 transition-transform" style={{ color: "var(--lm-ink-3)", transform: open ? "rotate(180deg)" : "rotate(0)" }} />
        </button>

        <button onClick={logout}
          className="w-full flex items-center justify-center gap-2 py-2 rounded-lg text-xs font-medium transition-colors"
          style={{ backgroundColor: "var(--lm-s2)", color: "var(--lm-ink-2)", border: "1px solid var(--lm-border)" }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = "rgba(239,68,68,0.08)"; e.currentTarget.style.color = "var(--lm-error)"; e.currentTarget.style.borderColor = "rgba(239,68,68,0.2)"; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = "var(--lm-s2)"; e.currentTarget.style.color = "var(--lm-ink-2)"; e.currentTarget.style.borderColor = "var(--lm-border)"; }}>
          <LogOut className="w-3.5 h-3.5" />
          {t('sidebar.userMenu.logout')}
        </button>
      </div>
    </div>
  );
};

export default SidebarUserProfile;
